import { Component, OnInit } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base';
import { AttributeModel } from 'src/app/main/dynamic/model/attribute.model';
import { OptionModel } from 'src/app/main/dynamic/model/option.model';

@Component({
  selector: 'app-switch',
  templateUrl: './switch-container.component.html',
  styleUrls: ['./switch-container.component.scss']
})
export class SwitchContainerComponent extends ComponentBase implements OnInit {

  textNotChecked: string = "";
  textChecked: string = "";

  constructor() { super() }

  ngOnInit() {
    this.textNotChecked = this.getOptionByKey(this.attribute, "TextNotChecked");
    this.textChecked = this.getOptionByKey(this.attribute, "TextChecked");
  }

  get isChecked(): boolean {
    if(!this.attribute.value) {
      return false;
    }

    return this.attribute.value.toLowerCase() == "true";
  }

  set value(checked: boolean) {
    this.attribute.value = String(checked);
  }

  onValueChange(event: any) {

    this.attribute.value = null;

    this.attribute.value = event.target.checked.toString();

    if (this.attribute.value.toLowerCase() == "false") {
      this.attribute.attributes.forEach(element => {
        if (element.value == null || element.value == "")
            element.value = " "
      });
    } else {
      this.attribute.attributes.forEach(element => {
        if (element.value == " ")
          element.value = ""
      });
    }

    this.emit({ name: "autosave", data: "silently" })
  }



  getEnvOptions(): OptionModel[] {
    return this.envOptions.concat(this.attribute.options
      .filter(opt => opt.key.toLowerCase() == "viewmode"))
  }

}
